(function() {
    'use strict';

    angular
        .module('setupApp')
        .controller('CityController', CityController);

    CityController.$inject = ['$scope', '$state', 'DataUtils', 'CityService', 'NgTableParams'];

    function CityController ($scope, $state, DataUtils, CityService, NgTableParams) {
        var vm = this;
        
        vm.city = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	CityService.query(function(result) {
                vm.city = result;
                vm.tableParams = new NgTableParams({
					page : 1, // show first page
					count : 20
				// count per page
				}, {
					filterDelay : 0,
					dataset : vm.city
				});
            });
        }
    }
})();
